import { useMutation } from '@tanstack/react-query';
import { api } from '../services/api';
import { ChatRequest, ChatResponse } from '../types/chat';

/**
 * Hook para interação com o endpoint de chat melhorado.
 * Suporta gráficos, insights, documentos e histórico de conversa.
 */
// Timeout de 5 minutos para requisições de chat (chamadas à IA podem demorar)
const CHAT_TIMEOUT = 300000;

export const useChatEnhanced = () => {
  const sendMessage = useMutation<ChatResponse, Error, ChatRequest>({
    mutationFn: async (payload: ChatRequest) => {
      const response = await api.post<ChatResponse>('/api/v1/chat/', payload, {
        timeout: CHAT_TIMEOUT,
      });
      return response.data;
    },
  });

  const sendSimpleMessage = useMutation<{ resposta: string }, Error, { mensagem: string }>({
    mutationFn: async (payload: { mensagem: string }) => {
      const response = await api.post<{ resposta: string }>('/api/v1/chat/simples', payload);
      return response.data;
    },
  });

  return {
    sendMessage,
    sendSimpleMessage,
  };
};

// Hook auxiliar para envio com debug
export const useChatDebug = () => {
  const sendMessage = useMutation<ChatResponse, Error, ChatRequest>({
    mutationFn: async (payload: ChatRequest) => {
      const response = await api.post<ChatResponse>('/api/v1/chat/?debug=true', payload);
      return response.data;
    },
  });

  return { sendMessage };
};
